import { MenuItem, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import "./Dashboard.css"
import CreateCampaignBtn from '../../Campaign/CreateCampaignBtn/CreateCampaignBtn';
import { useSelector } from 'react-redux';

const Dashboard = ({campaigns, currentCampaign, setCurrentCampaign})=> {
    const homePageProfile = useSelector(state => state.homePageProfile.data)

    function handleSelectChange(event){
        console.log(event)
    }
    function handleSelectDurationChange(event){}

    useEffect(() => {
        if (campaigns?.length)  setCurrentCampaign(campaigns[0]?.campaign_name)
    }, [campaigns])



  return (
    <div id='dashboard'>
        <div id="dashboardHeading">
            <div>
                <h1 className="dashboard-heading">Dashboard</h1>
                <p className="dashboard-subHeading">Check insights of your campaigns</p>
            </div>
            <CreateCampaignBtn  url='/create-campaign' text="Create new Campaign" />
        </div>
        {campaigns && <div id="dashboardFilter">
            {/* <TextField sx={{minWidth: "10rem", borderRadius: "0.5rem", backgroundColor: "#fff", marginRight: "1rem"}} select value={currentCampaign}  onChange={(e, newVal) =>setCurrentCampaign(e.target.value)} >
            {campaigns?.map(item =>{
                    return   <MenuItem value={item?.campaign_name} >{item?.campaign_name}</MenuItem>
                })}
            </TextField> */}
            {/* <select class="form-select selector" aria-label="Default select example" onChange={handleSelectChange}>
                {campaigns?.map(item =>{
                    return   <option value={item?.campaign_name} >{item?.campaign_name}</option>
                })}
            </select> */}
            {/* <TextField defaultValue="Last 30 days" sx={{minWidth: "10rem", borderRadius: "0.5rem", backgroundColor: "#fff"}} select  >
                <MenuItem value="Last 30 days">Last 30 days</MenuItem>
                <MenuItem value="Last 3 months">Last 3 months</MenuItem>
                <MenuItem value="Last 3 months">Last 6 months</MenuItem>
                <MenuItem value="Last 1 year">Last 1 Year</MenuItem>
            </TextField> */}
            {/* <select class="form-select selector" aria-label="Default select example" onChange={handleSelectDurationChange}>
            <option selected>Last 30 days</option>
            <option value="L3M">Last 3 months</option>
            <option value="L6M">Last 6 months</option>
            <option value="L1Y">Last 1 year</option>
            </select> */}
        </div>}
    </div>
  )
}

export default Dashboard